
import { useState } from 'react';
import { useToast } from '@/hooks/use-toast';
import { supabase } from '@/integrations/supabase/client';
import { Integration } from '@/types/integrations';

export const useNuvemshopSync = (integration?: Integration) => {
  const { toast } = useToast();
  const [isSyncing, setIsSyncing] = useState(false);

  const handleSyncCustomers = async () => {
    if (!integration) return;
    
    setIsSyncing(true);
    try {
      const { data, error } = await supabase.functions.invoke('nuvemshop-integration', {
        body: {
          action: 'sync_customers',
          userId: integration.user_id
        }
      });

      if (error) throw error;

      toast({
        title: "Sincronização concluída",
        description: `${data.synced} clientes sincronizados de ${data.total} encontrados`
      });
    } catch (error: any) {
      toast({
        title: "Erro na sincronização",
        description: error.message,
        variant: "destructive"
      });
    } finally {
      setIsSyncing(false);
    }
  };

  const handleSyncOrders = async () => {
    if (!integration) return;
    
    setIsSyncing(true);
    try {
      const { data, error } = await supabase.functions.invoke('nuvemshop-integration', {
        body: {
          action: 'sync_orders',
          userId: integration.user_id
        }
      });

      if (error) throw error;

      toast({
        title: "Sincronização concluída",
        description: `${data.synced} pedidos sincronizados de ${data.total} encontrados`
      });
    } catch (error: any) {
      toast({
        title: "Erro na sincronização",
        description: error.message,
        variant: "destructive"
      });
    } finally {
      setIsSyncing(false);
    }
  };

  return {
    handleSyncCustomers,
    handleSyncOrders,
    isSyncing
  };
};
